import { useState } from "react";


export const usePutScrapFinanceAccountStates = () => {
  const [scrapFinanceAccountId, setScrapFinanceAccountId] = useState("");
  const [scrapFinanceId, setScrapFinanceId] = useState("");

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    scrapFinanceAccountId,
    setScrapFinanceAccountId,
    scrapFinanceId,
    setScrapFinanceId,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
